export default "__VITE_ASSET__ZtOe7wiA__"